import React from 'react';
import gql from 'graphql-tag';
import { withRouter } from 'react-router';
import { injectIntl } from 'react-intl';

import { buildPracticeSchedulingUrl } from '../../shared/utils/urls';
import WidgetHeader from './WidgetHeader';

class WidgetOfficeHeader extends React.Component {
  render() {
    const { intl, history, office } = this.props;
    return (
      <WidgetHeader
        title={office.practice.display}
        subtitle={office.display}
        photo={office.practice.logo}
        photo2x={office.practice.logo2x}
        changeUrl={buildPracticeSchedulingUrl(office.practice.id, { location: history.location })}
        changeText={intl.formatMessage({
          id: 'widgets.WidgetOfficeHeader.changeText',
          defaultMessage: 'Change Office',
        })}
        showBackButton
      />
    );
  }
}

const WidgetOfficeHeaderWithIntl = injectIntl(withRouter(WidgetOfficeHeader));

WidgetOfficeHeaderWithIntl.fragment = {
  name: 'WidgetOfficeHeader',
  query: gql`
    fragment WidgetOfficeHeader on Office {
      id
      display
      practice {
        id
        display
        logo: logo(size: 35)
        logo2x: logo(size: 70)
      }
    }
  `,
};

export default WidgetOfficeHeaderWithIntl;
